import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../index';
import { verifyPhoneCloseModalAction, verifyPhoneSetErrorMessageAction } from '@cian/sms-validation-widget';

export const verifyPhoneCloseModal = (): ThunkAction<void, IState, IContext> => {
  return async (dispatch) => {
    dispatch(verifyPhoneSetErrorMessageAction(''));
    dispatch(verifyPhoneCloseModalAction());
  };
};
